import * as serviceContext from "../services/serviceContext";

var options = {};
var headers = new Headers();

headers.append(
  "Content-Type",
  "application/json",
  "Access-Control-Allow-Origin",
  // "http://localhost:5000/",
  "process.env.REACT_APP_API_BASEURL",
  "*"
);
options.headers = headers;

export async function getreports() {
  try {
    const response = await serviceContext.get(
      "/tracking_report",
      null,
      options
    );
    const res = response.json();
    return res;
  } catch (error) {
    return error;
  }
}
